import { useDataFormStore } from "@/stores/form";

let cargoTypes = {
    'Стандарт' : 1,
    'Цилиндры' : 2,
    'Шины' : 3,
}

export function requiredNeeded() {
  const dataForm = useDataFormStore();
  
  let radioUser = ((dataForm.consigneeInnRadio && dataForm.payment.whoPaysForCargoTransportation == "") || (dataForm.payment.whoPaysForCargoTransportation != "" && !checkPay())) ? true : false;
  return !(radioUser && dataForm.other.cargoCost < 100000);
}

// Функция для проверки блокировки переключателя для Забора груза и Доставки до двери
export function blockPickupSwitch(type) {

    const dataForm = useDataFormStore();

    let weight = 0;
    let length = 0;
    let width = 0;
    let height = 0;
    let diameter = 0;
    let cylinderHeight = 0;

    let restrictions = false;

    if (dataForm.cargoInformation.cargoSpaceType == 'simple') {

        // Блокировка подсчета если значение количество мест для посылки пустое
        if(!dataForm.cargoInformation.numberOfIdenticalLoads) return false;

        switch (cargoTypes[dataForm.cargoInformation.typeOfCargo]) {
            case 1:
            weight = Number(dataForm.cargoInformation.cargoWeight);
            length = parseFloat(dataForm.cargoInformation.cargoDimensions.length);
            width = parseFloat(dataForm.cargoInformation.cargoDimensions.width);
            height = parseFloat(dataForm.cargoInformation.cargoDimensions.height);
            break;
            case 2:
            weight = Number(dataForm.cargoInformation.cargoWeight);
            cylinderHeight = parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.height);
            diameter = parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.diameter);
            break;
        }

    } else {

        // берем максимальные значения со всех посылок чтобы посчитать их с ограничениями склада
        dataForm.cargoSpaceTabs.forEach(tab => {
            switch (cargoTypes[tab.typeOfCargo]) {
                case 1:
                  weight = (weight < Number(tab.cargoWeight)) ? Number(tab.cargoWeight) : weight;
                  length = (length < parseFloat(tab.length)) ? parseFloat(tab.length) : length;
                  width = (width < parseFloat(tab.width)) ? parseFloat(tab.width) : width;
                  height = (height < parseFloat(tab.height)) ? parseFloat(tab.height) : height;
                  break;
                case 2:
                  weight = (weight < Number(tab.cargoWeight)) ? Number(tab.cargoWeight) : weight;
                  cylinderHeight = (weight < parseFloat(tab.height)) ? parseFloat(tab.height) : cylinderHeight;
                  diameter = (diameter < parseFloat(tab.diameter)) ? parseFloat(tab.diameter) : diameter;
                  break;
            }
        });

    }

    if (type == "from") {
        restrictions = dataForm.sender.officeFromEmpty;
    } else {
        restrictions = dataForm.consignee.officeToEmpty;
    }
    

    if(restrictions) {
        if (type == "from") {
            dataForm.applicationCargoPickup.isCargoPickup = true;
        } else {
            dataForm.applicationCargoPickup.deliveryToTheAddress = true;
        }  
    }
    

    let cityEmpty = (type == "from") ? (dataForm.sender.cityFrom == '') : (dataForm.consignee.cityTo == '')

    return (
      cityEmpty ||
      restrictions 
    )
}

// функция для скрытия и показа уведомлений о складе
export function checkStorage(type){

    const dataForm = useDataFormStore();

    let weight = 0;
    let length = 0;
    let width = 0;
    let height = 0;
    let diameter = 0;
    let cylinderHeight = 0;

    let restrictions = false;
    let restrictionsAdditional = false;

    let refused = false;
    
    if (dataForm.cargoInformation.cargoSpaceType == 'simple') {
      switch (cargoTypes[dataForm.cargoInformation.typeOfCargo]) {
        case 1:
          weight = Number(dataForm.cargoInformation.cargoWeight);
          length = parseFloat(dataForm.cargoInformation.cargoDimensions.length);
          width = parseFloat(dataForm.cargoInformation.cargoDimensions.width);
          height = parseFloat(dataForm.cargoInformation.cargoDimensions.height);
          break;
        case 2:
          weight = Number(dataForm.cargoInformation.cargoWeight);
          cylinderHeight = parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.height);
          diameter = parseFloat(dataForm.cargoInformation.sizeOfCargoCylinder.diameter);
          break;
      }
    } else {

      // берем максимальные значения со всех посылок чтобы посчитать их с ограничениями склада
      dataForm.cargoSpaceTabs.forEach(tab => {
        switch (cargoTypes[tab.typeOfCargo]) {
            case 1:
              weight = (weight < Number(tab.cargoWeight)) ? Number(tab.cargoWeight) : weight;
              length = (length < parseFloat(tab.length)) ? parseFloat(tab.length) : length;
              width = (width < parseFloat(tab.width)) ? parseFloat(tab.width) : width;
              height = (height < parseFloat(tab.height)) ? parseFloat(tab.height) : height;
              break;
            case 2:
              weight = (weight < Number(tab.cargoWeight)) ? Number(tab.cargoWeight) : weight;
              cylinderHeight = (weight < parseFloat(tab.height)) ? parseFloat(tab.height) : cylinderHeight;
              diameter = (diameter < parseFloat(tab.diameter)) ? parseFloat(tab.diameter) : diameter;
              break;
        }
       });
    
    }

    if (type == "from") {

        refused = dataForm.sender.officeFromRefuse

        restrictions = refused

        restrictionsAdditional = (dataForm.sender.cityFrom == '') ||
        dataForm.sender.officeFromEmpty ||
        dataForm.applicationCargoPickup.isCargoPickup

    } else {

      refused = dataForm.consignee.officeToRefuse

        restrictions = refused;

        restrictionsAdditional = (dataForm.consignee.cityTo == '') ||
        dataForm.consignee.officeToEmpty ||
        dataForm.applicationCargoPickup.deliveryToTheAddress 

    }

    return(
        restrictions && !(restrictionsAdditional)
    );

}

const convertToEnglish = (value) => value === "Отправитель" ? "Sender" : value === "Получатель" ? "Consignee" : value === "Третье лицо" ? "Customer" : ""

export function checkPay() {
  const dataForm = useDataFormStore();
  
  let whoPay = dataForm.payment.whoPaysForCargoTransportation

  let result = false;
  
  switch (convertToEnglish(whoPay)) {
    case 'Sender':
      result = !dataForm.sender.senderType;
      break;
    case 'Consignee':
      result = !dataForm.consignee.consigneeType;
      break;
    case 'Customer':
      result = !dataForm.thirdPerson.typeThirdPerson;
      
      break;
  }

  return result;

}

export function checkCityRoadFrom() {
  const dataForm = useDataFormStore();
  return dataForm.sender.cityFrom == "Мишкино (Курган)" ||
  dataForm.sender.cityFrom == "Юргамыш (Курган)"||
  dataForm.sender.cityFrom == "Каргаполье (Курган)";
}

export function checkCityRoadTo() {
  const dataForm = useDataFormStore();
  return dataForm.consignee.cityTo == "Мишкино (Курган)" ||
  dataForm.consignee.cityTo == "Юргамыш (Курган)"||
  dataForm.consignee.cityTo == "Каргаполье (Курган)";
}